import { render, staticRenderFns } from "./CustomerBudgetTable.vue?vue&type=template&id=a40f6c4e&scoped=true"
import script from "./CustomerBudgetTable.vue?vue&type=script&lang=ts"
export * from "./CustomerBudgetTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomerBudgetTable.vue?vue&type=style&index=0&id=a40f6c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40f6c4e",
  null
  
)

export default component.exports